import React from "react";
import image from "../../Assets/images/spinner.gif";
// import Loader from "react-loader-spinner";
const LoadingIcon = ({ is_loading, className, children }) =>
  is_loading ? (
    <div className="spinner-border" role="status"></div>
  ) : (
    <i className={className}>{children}</i>
  );
export default LoadingIcon;
